module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp3_0.a2ae63f9.png";